// extracted by mini-css-extract-plugin
export var _default = "button-module--_default--EpCEo";
export var big = "button-module--big--tLzBs";
export var button = "button-module--button--8ccuq";
export var button_icon = "button-module--button_icon--IlcMI";
export var disabled = "button-module--disabled--cFKgb";
export var empty = "button-module--empty--NHQVw";
export var empty_all = "button-module--empty_all--AgHQV";
export var for_tab = "button-module--for_tab--JwvXL";
export var ghost = "button-module--ghost--sf70Z";
export var is_icon_show = "button-module--is_icon_show--ixSnJ";
export var is_text_show = "button-module--is_text_show--ilPIv";
export var large = "button-module--large--CB2ia";
export var medium = "button-module--medium--283uF";
export var regSmall = "button-module--reg-small--TQ5oq";
export var secondary = "button-module--secondary--tkVGo";